import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../features/auth/services/auth.service';
import { map, catchError, of } from 'rxjs';

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  
  const user = authService.currentUser();
  
  if (user) {
    if (user.profile?.toLowerCase() === 'admin') return true;
    router.navigate(['/dashboard']);
    return false;
  }
  
  // If reloading the page directly on the protected route, fetch user info
  return authService.getUserInfo().pipe(
    map(userData => {
      if (userData?.profile?.toLowerCase() === 'admin') {
        return true;
      }
      router.navigate(['/dashboard']);
      return false;
    }),
    catchError(() => {
      router.navigate(['/dashboard']);
      return of(false);
    })
  );
};
